import React, { useState } from 'react'
import styled from 'styled-components'

import { ArrowIcon, UserIcon } from '@/components/ui/icons'
import { useCurrentUserProfile } from '@/utils/user'

const BUTTON_HEIGHT = 36

const Container = styled.div`
  display: flex;
  width: 200px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  position: relative;
`

const Avatar = styled.div`
  display: flex;
  width: ${BUTTON_HEIGHT}px;
  height: ${BUTTON_HEIGHT}px;
  background: ${({ theme }) => theme.palette.giphyLightCharcoal};
`

const AvatarImage = styled.img`
  && {
    width: 100%;
  }
`

const LoginUser = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.palette.giphyDarkCharcoal};
  width: 100%;
  height: ${BUTTON_HEIGHT}px;
  justify-content: space-between;
`

const ArrowContainer = styled.span`
  width: 40px;
`

const Text = styled.a`
  width: 100%;
  display: flex;
  justify-content: center;
  text-decoration: none;
  border-bottom: none;
`

const DropdownMenu = styled.div`
  width: 100%;
  position: absolute;
  top: ${BUTTON_HEIGHT}px;
  background: ${({ theme }) => theme.palette.giphyDarkCharcoal};
  font-size: 15px;
  border-top: 4px solid black;
`

const MenuItem = styled.a`
  text-decoration: none;
  border-bottom: none;
  height: ${BUTTON_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    border-bottom: 1px solid ${({ theme }) => theme.palette.giphyLightCharcoal};
  }

  &:hover {
    background: ${({ theme }) => theme.palette.giphyLightCharcoal};
  }
`

export const AccountMenu: React.FC = () => {
  const { data: user } = useCurrentUserProfile()
  const [showDropdown, setShowDropdown] = useState(false)

  const onMouseEnter = () => setShowDropdown(true)

  const onMouseLeave = () => setShowDropdown(false)

  return (
    <Container onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Avatar>{user ? <AvatarImage src={user?.avatar_url} /> : <UserIcon />}</Avatar>
      <LoginUser>
        {user ? (
          <>
            <Text href="/dashboard">{user?.display_name || user?.username}</Text>
            <ArrowContainer>
              <ArrowIcon rotate={0} />
            </ArrowContainer>
          </>
        ) : (
          <Text href="/dashboard">Log In</Text>
        )}
      </LoginUser>

      {showDropdown && user && (
        <DropdownMenu>
          <MenuItem href="/dashboard">Dashboard</MenuItem>
          <MenuItem href="/logout?next=/">Logout</MenuItem>
        </DropdownMenu>
      )}
    </Container>
  )
}
